<template>
  <UIDialog
    :is-open
    :z-index
    flat
    unclosable
    class="add-account-yodlee"
    @close="handleClose"
  >
    <div :id="containerId" class="add-account-yodlee__container">
      <UIPreloader class="add-account-yodlee__preloader" message="Loading Yodlee..." />
    </div>
  </UIDialog>
</template>

<script setup lang="ts">
import { computed, getCurrentInstance } from 'vue'

import { ModalClass } from '@types'

import { UIDialog } from '@ui/modals'
import { UIPreloader } from '@ui/core'

type Props = {
  modal: ModalClass<any>
}

const props = defineProps<Props>()

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)

const containerId = computed(
  () => `container-fastlink-${getCurrentInstance()?.uid.toString()}`,
)

const handleClose = () => {
  props.modal.close()
  ;(window as Window & typeof globalThis & { fastlink: any }).fastlink.close()
}
</script>

<style scoped>
.add-account-yodlee {
  &__container {
    @apply relative min-h-96;
    @apply focus:outline-none;
    @apply z-30;
  }

  &__preloader {
    @apply absolute -z-10;
    @apply top-1/2 left-1/2;
    @apply -translate-x-1/2 -translate-y-1/2;
  }
}
</style>
